import { Cancel } from '@elhub/ds-icons/dist/Cancel';
import React from 'react';
const ValueRemove = (props) => {
    return (React.createElement("div", Object.assign({ style: { cursor: 'pointer' } }, props.innerProps),
        React.createElement(Cancel, { size: props.size === 'medium' ? '1.5rem' : '1.2rem' })));
};
ValueRemove.displayName = 'SelectMultiple.ValueRemove';
export default ValueRemove;
